import styled from 'styled-components';

import alert from '~/assets/alert.svg';

export const ErrorSpan = styled.span`
  color: #c11e1e;
  margin: 5px 0;
  font-weight: normal;

  :before {
    content: url(${alert});
    padding: 0 10px 0 0;
    vertical-align: -10%;
  }
`;

export const Container = styled.div`
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const Content = styled.div`
  width: 100%;
  background: #fff;
  border-radius: 4px;

  span {
    display: block;
    font-weight: bold;
    margin: 20px 0 8px 0;
  }

  ${ErrorSpan} {
    font-weight: normal;
  }
`;

export const CategorySubTitle = styled.p`
  font-weight: bold;
  margin-top: 16px;
`;
